import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Typography from "@mui/material/Typography";

export type Web3InteractionStep = {
  label: () => string;
  Description: () => JSX.Element;
  caption?: () => string;
};
export interface IWeb3InteractionStepperProps {
  activeStep: number;
  steps: Web3InteractionStep[];
}
export const Web3InteractionStepper = ({
  activeStep,
  steps,
}: IWeb3InteractionStepperProps) => {
  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel
              optional={
                step.caption && (
                  <Typography variant="caption">{step.caption?.()}</Typography>
                )
              }
            >
              {step.label()}
            </StepLabel>
            <StepContent>{step.Description()}</StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
